import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 15000,  // 15s — prevents infinite loading on slow API
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global error handler: prevents black screen on timeout/network errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ECONNABORTED") {
      console.warn("[api] request timeout:", error.config?.url);
    } else if (!error.response) {
      console.warn("[api] network error:", error.config?.url);
    } else if (error.response.status >= 500) {
      console.warn("[api] server error:", error.response.status, error.config?.url);
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => 
  api.post("/auth/login", { email, password });

export const register = (email, password) => 
  api.post("/auth/register", { email, password });

export const getMe = () => api.get("/auth/me");

// Articles
export const getArticles = (params = {}) => 
  api.get("/articles", { params });

export const getArticle = (id) => 
  api.get(`/articles/${id}`);

export const createArticle = (data) => 
  api.post("/articles", data);

export const updateArticle = (id, data) => 
  api.put(`/articles/${id}`, data);

export const deleteArticle = (id) => 
  api.delete(`/articles/${id}`);

export const archiveArticle = (id) =>
  api.post(`/articles/${id}/archive`);

// Categories
export const getCategories = () => api.get("/categories");

// AI
export const aiRewrite = (data) => 
  api.post("/ai/rewrite", data);

export const aiGenerateArticle = (data) => 
  api.post("/ai/generate-article", data);

// Monitored Sites
export const getMonitoredSites = () => api.get("/monitored-sites");

// Stats
export const getStats = () => api.get("/stats");

// Upload
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Seed
export const seedData = () => api.post("/seed");

export default api;
